module.exports = __webpack_public_path__ + "static/img/4.50e0920.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/4.png
// module id = Dply
// module chunks = 0